import ajax from '../utils/ajax';
import { SubmitResponse } from './types';

async function submit(formData: any): Promise<SubmitResponse> {
  const res = await ajax.postWwwFormUrlEncoded('/api/onepage/onepagegiving/submit', formData);

  if (!res.type) {
    throw new Error();
  }

  return res;
}

export default {
  submit,
};
